import * as React from "react";
import { Box, Card, Tab, Tabs } from "@mui/material";
import AddNewInsurance from "../Add Insurance/AddInsurance";
import RenewInsurance from "../Renew Insurance/Renew";
import PageHeader from "../../ui/PageHeader";

export default function Insurance() {
  const [value, setValue] = React.useState(0);

  return (
    <Box>
      <PageHeader
        title="Insurance"
        subtitle="Record new policies and renew ones that are maturing. Both go to an approver before they count."
      />
      <Card>
        <Tabs
          value={value}
          onChange={(e, v) => setValue(v)}
          sx={{ px: 2, borderBottom: 1, borderColor: "divider" }}
          textColor="primary"
          indicatorColor="secondary"
        >
          <Tab label="All policies" id="insurance-tab-0" aria-controls="insurance-panel-0" />
          <Tab label="Renewals" id="insurance-tab-1" aria-controls="insurance-panel-1" />
        </Tabs>
        <Box role="tabpanel" id={`insurance-panel-${value}`} aria-labelledby={`insurance-tab-${value}`} sx={{ p: { xs: 1.5, md: 2 } }}>
          {value === 0 ? <AddNewInsurance /> : <RenewInsurance />}
        </Box>
      </Card>
    </Box>
  );
}
